<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.configuracaoRastreabilidade.materiais.titulo")',
        :voltarPara='{ route: "ConfiguracaoMaterial" }'
    )
    .detalhes-gerente-comercial
        h3.detalhes-gerente-comercial__titulo {{ $t('mensagens.configuracaoRastreabilidade.materiais.dadosCadastrais') }}
        .detalhes-gerente-comercial__card
            Resume(resumeId='detalhes-material', :resume='resumeList')
        .footer
            .footer__btn.voltar(@click='irParaGerentesComerciais')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.comuns.voltar') }}
</template>
<script>
import services from '@/services/ContratoOriginacaoService';

export default {
    name: 'DetalhesMaterial',
    components: {
        BaseHeader: () => import('@/components/BaseHeader'),
        Resume: () =>
            import('@/components/contratosOriginacao/formulario/Resume')
    },
    data() {
        return {
            material: {}
        };
    },
    computed: {
        resumeList() {
            const resume = [
                {
                    key: 'codigo',
                    label: this.$t('mensagens.configuracaoRastreabilidade.materiais.detalhes.codigo'),
                    value: this.material?.codigo || '--'
                },
                {
                    key: 'nome',
                    label: this.$t('mensagens.configuracaoRastreabilidade.materiais.detalhes.nome'),
                    value: this.material?.nome || '--'
                },
                {
                    key: 'tipo',
                    label: this.$t('mensagens.configuracaoRastreabilidade.materiais.detalhes.tipo'),
                    value: this.material?.tipoMaterialOuput?.nome || '--'
                }
            ];

            if (this.material?.tipoSubprodutoOutput) {
                resume.push({
                    key: 'subproduto',
                    label: this.$t('mensagens.configuracaoRastreabilidade.materiais.detalhes.subproduto'),
                    value: this.material?.tipoSubprodutoOutput.nome || '--'
                });
            }

            if (this.material?.materialOrigem) {
                resume.push({
                    key: 'materialOrigem',
                    label: this.$t('mensagens.configuracaoRastreabilidade.materiais.detalhes.materialOrigem'),
                    value: this.material?.materialOrigem?.nome || '--'
                });
            }

            return resume;
        }
    },
    mounted() {
        this.buscarDados();
    },
    methods: {
        async buscarDados() {
            const id = this.$route.params.id;

            await services.detalheMaterial(id)
                .then(({ data }) => {
                    this.material = data;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error.response.data.message
                    });
                    this.$router.push({ path: '/materiais' });
                });
        },
        irParaGerentesComerciais() {
            this.$router.push({ name: 'ConfiguracaoMaterial' });
        }
    }
};
</script>

<style lang="scss" scoped>
.detalhes-gerente-comercial {
    margin: 20px;

    &__titulo {
        margin-top: 24px;
        font-weight: 500;
    }

    &__card {
        margin-top: 10px;
        background-color: $white;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        border-radius: $default-border-radius;
        @include default-box-shadow();

        &+& {
            margin-top: 20px;
        }
    }
}

.footer {
    display: flex;
    justify-content: flex-end !important;
    margin-top: 20px;
}

.footer__btn {
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: $default-border-radius;
    cursor: pointer;

    .mdi-arrow-left {
        color: var(--primary);
    }

    .mdi-arrow-right {
        color: $white;
    }
}

.footer__btn.voltar {
    background-color: transparent;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.footer__btn.voltar:hover {
    background-color: var(--primary);
    color: $white;

    .mdi-arrow-left {
        color: $white;
    }
}
</style>
